import request from '@/services/request';

const BASE = 'payment';

export const paymentIntent = {
  create: (params, stripeAccount) => request.post(`${BASE}/intent/create`, { params, stripeAccount }),
  save: params => request.post('payments', params),
  getMyTransactions: pagination => request.get('payments/transaction/list', { params: pagination }),
  findByContentId: id => request.get('payments/transaction/content', { params: { id } }),
  getMySupporters: pagination => request.get('payments/transaction/supporters', {
    params: pagination,
  }),
};

export const setupIntent = {
  create: () => request.post(`${BASE}/setup-intents`),
};

export const connectedAccount = {
  create: params => request.post(`${BASE}/account`, params),
  deauthorize: () => request.delete(`${BASE}/account`),
  retrieve: id => request.get(`${BASE}/account/${id}`),
  link: {
    create: id => request.post(`${BASE}/account/${id}/link`),
  },
  balance: {
    retrieve: id => request.get(`${BASE}/account/${id}/balance`),
  },
};

export const customer = {
  create: (params, stripeAccount = null) => request.post(`${BASE}/customer/create`, params, { params: { stripeAccount } }),
  retrieve: id => request.get(`${BASE}/customer/${id}`),
  update: (id, params) => request.put(`${BASE}/customer/${id}`, params),
  attachPaymentMethod: ({ customerId, paymentMethodId }) => request.put(`${BASE}/customer/${customerId}/payment-methods/${paymentMethodId}/attach`),
  getPaymentMethods: ({ customerId }) => request.get(`${BASE}/customer/${customerId}/payment-methods`),
  deletePaymentMethod: ({ customerId, paymentMethodId }) => request.delete(`${BASE}/customer/${customerId}/payment-methods/${paymentMethodId}`),
  setDefaultPaymentMethod: ({ customerId, paymentMethodId }) => request.put(`${BASE}/customer/${customerId}/payment-methods/${paymentMethodId}/set-default`),
  getCurrentPlan: ({ customerId }) => request.get(`${BASE}/customer/${customerId}/current-plan`),
  payInvoice: ({ customerId, invoiceId }) => request.post(`${BASE}/customer/${customerId}/invoices/${invoiceId}/pay`),
};

export const subscription = {
  create: body => request.post(`${BASE}/subscription`, body),
  cancel: (id, stripeAccount) => request.delete(`${BASE}/subscription/${id}`, { params: { stripeAccount } }),
  save: data => request.post('payments', data),
  update: (id, params) => request.put(`payments/${id}`, params),
  getMySubscriptions: pagination => request.get('payments/subscription/list', { params: pagination }),
  findByCreatorId: id => request.get(`payments/subscription/creator/${id}`),
  getMySubscribers: params => request.get('subscription/my-subscribers', { params }),
  doIHaveSubscription: creatorId => request.get('payments/subscription/do-i-have-subscription', { params: { creatorId } }),
};

export const getAllMyPurchases = pagination => request.get('payments/list', { params: pagination });

export const freeSubscription = {
  getMyFreeSubscriptions: pagination => request.get('payments/free-subscription/list', { params: pagination }),
  findByCreatorId: id => request.get(`payments/free-subscription/creator/${id}`),
};

export const digitalItem = {
  getMyDigitalItems: pagination => request.get('payments/digital-item/list', { params: pagination }),
  findByCreatorId: id => request.get(`payments/digital-item/creator/${id}`),
};

export const product = {
  create: (params, stripeAccount) => request.post(`${BASE}/product/create`, params, { params: { stripeAccount } }),
  retrieve: (id, stripeAccount) => request.get(`${BASE}/product/${id}`, { params: { stripeAccount } }),
  update: (id, params, stripeAccount) => request.put(`${BASE}/product/${id}/update`, params, { params: { stripeAccount } }),
};

export const price = {
  create: (params, stripeAccount) => request.post(`${BASE}/price/create`, params, { params: { stripeAccount } }),
  retrieve: (id, stripeAccount) => request.get(`${BASE}/price/${id}`, { params: { stripeAccount } }),
  retrieveNew: (id, params) => request.get(`${BASE}/price/${id}/new`, { params }),
  update: (id, params, stripeAccount) => request.put(`${BASE}/price/${id}/update`, params, { params: { stripeAccount } }),
};

export const token = {
  create: body => request.post(`${BASE}/token/create`, body),
};

export const coupon = {
  verify: (code, priceId) => request.get(`${BASE}/coupon/${code}/verify`, {
    params: {
      priceId,
    },
  }),
};

export const retrieveCoupon = code => request.get(`${BASE}/coupon/${code}`);
export const purchaseClasses = (promotionCode, metadata) => request.post(
  `${BASE}/coupon/apply`,
  metadata,
  { params: { promotionCode } },
);
